// Раздел по адресу — для стража маршрутов (components/NavRouteGuard.tsx).
// Вынесено из компонента: react-refresh требует, чтобы файл компонента
// экспортировал только компоненты.
import { NAV_PATHS } from '../api/nav'

/** Раздел, которому принадлежит адрес: самое длинное совпадение по границе сегмента. */
export function sectionIdForPath(pathname: string): string | null {
	let best: { id: string; len: number } | null = null
	for (const { id, path } of NAV_PATHS) {
		if (pathname === path || pathname.startsWith(`${path}/`)) {
			if (!best || path.length > best.len) best = { id, len: path.length }
		}
	}
	return best?.id ?? null
}

/** Публичные страницы ПОД префиксом раздела: страж сопоставляет адрес по префиксу, поэтому закрытый
 *  раздел утягивал за собой и их. Проверка подписи документа обязана открываться всем — её ключ
 *  стоит в штампе, а получатель заведомо не сотрудник (12.09: анонимного уносило на /bots). */
export const PUBLIC_UNDER_SECTION = [/^\/assistants\/verify(\/|$)/]

/** Адрес открыт всем независимо от настройки раздела. */
export function publicUnderSection(pathname: string): boolean {
	return PUBLIC_UNDER_SECTION.some((re) => re.test(pathname))
}
